/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

module.exports = Point
/**
 * Classe représentant un point par ses coordonnées.
 * Utilisé de façon interne.
 * @constructor
 * @param {Float} x
 * @param {Float} y
 * @returns {Point}
 */
function Point (x, y){
  if (arguments.length === 0) {
    this.x = 0;
    this.y = 0;
  }
  else {
    this.x = x;
    this.y = y;
  }
}
